<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-24 14:57:23
 * @ Modified by: Your name
 * @ Modified time: 2019-07-15 16:29:01
 * @ Description: 登录
 -->

<template>
  <div class="login-wrapper">
    <div class="login-content">
      <p class="title">
        智能航材配送柜
      </p>
      <el-form
        :model="loginForm" :rules="loginRules" ref="loginForm"
        label-position="left" label-width="0px" class="card-box login-form">
        <el-form-item prop="loginName" class="form-item">
          <i class="icon-weibiaoti562"></i>
          <el-input name="loginName" type="text" v-model="loginForm.loginName"
            placeholder="用户名或手机号" autocomplete='on' clearable></el-input>
        </el-form-item>
        <el-form-item prop="password" class="form-item">
          <i class="icon-mima"></i>
          <el-input name="password" type="password" @keyup.enter.native="handleLogin"
            v-model="loginForm.password" placeholder="密码" clearable></el-input>
        </el-form-item>
        <el-form-item class="form-item">
          <el-button type="primary" class="login-btn"
            :loading="loading" @click="handleLogin">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { LOGIN, GETMENULIST } from '../../libs/api'
import { aesEncrypt } from '../../libs/utils/encrypt'
import { validatePass, onlyNumberLetter } from '../../libs/utils/validCheck'
import { getAllMenuList } from '../../libs/utils/getMenuList'

export default {
  name: 'login',
  data() {
    const onlyNumberLetters = (rule, value, callback) => {
      onlyNumberLetter(rule, value, callback)
    }
    const validatePassS = (rule, value, callback) => {
      validatePass(rule, value, callback)
    }

    return {
      loginForm: {
        loginName: '',
        password: ''
      },
      loginRules: {
        /* eslint-disable */
        loginName: [{ required: true, trigger: 'blur', message: '请输入用户名或手机号' },
          { validator: onlyNumberLetters, trigger: 'blur' }],
        password: [{ required: true, trigger: 'blur', validator: validatePassS, message: '请输入不小于5位数密码' },
          { validator: onlyNumberLetters, trigger: 'blur' }]
      },
      loading: false,
      getMenUrl: GETMENULIST.GETMENU
    }
  },
  created() {
    this.selectBrowser()
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 对密码进行加密
          this.loginForm.password = aesEncrypt(this.loginForm.password, 'USER')
          this.$http.post(LOGIN.LOGIN, this.loginForm)
            .then(res => {
              this.loading = false
              if (res.data.code === 1) {
                sessionStorage.setItem('token', res.data.data.token)
                sessionStorage.setItem('userName', res.data.data.userName)
                sessionStorage.setItem('userId', res.data.data.id)

                getAllMenuList().then(res => { // 默认跳转到有权限的第一个路由
                  if (res.length > 0) {
                    this.$router.push(`/index/${res[0].path}`)
                  }
                })
              } else {
                this.$message.error(res.data.msg || '登录名或密码错误！')
              }
            }).catch(err => {
              this.loading = false
              this.$message.error(err || '登录失败')
            })
          return ''
        }
        return false
      })
    },
    selectBrowser() {
      const mb = this.myBrowser()
      if ("IE" == mb) {
        this.$notify({
          title: '建议',
          message: '现在使用的是IE模式的浏览器，建议使用Chrome浏览器',
          type: 'warning',
          duration: 0
        })
      }
    },
    myBrowser() { // 检测浏览器类型
      const userAgent = navigator.userAgent //取得浏览器的userAgent字符串
      const isOpera = userAgent.indexOf("Opera") > -1
      if (isOpera) {
          return "Opera"
      } //判断是否Opera浏览器
      if (userAgent.indexOf("Firefox") > -1) {
          return "FF"
      } //判断是否Firefox浏览器
      if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome"
      }
      if (userAgent.indexOf("Safari") > -1) {
          return "Safari"
      } //判断是否Safari浏览器
      if (userAgent.indexOf("Trident") > -1) {
          return "IE"
      } //判断是否IE浏览器
    }
  }
}
</script>

<style lang="scss" scoped>
  .login-wrapper{
    background: url('../../assets/imgs/bg/background.png');
    background-size: cover;
    height: 100%;
    & > .login-content {
      position: absolute;
      left:50%;
      top:50%;
      transform: translate(-50%,-50%);
      & > .title{
        font-size:60px;
        font-family:PingFangSC-Semibold;
        font-weight:600;
        color:rgba(47,74,105,1);
        line-height:84px;
        text-align: center;
        margin-bottom: 50px;
      }
      & > .login-form{
        width:548px;
        height:364px;
        background:rgba(255,255,255,0.4);
        box-shadow:0px 2px 4px 0px rgba(0,0,0,0.5);
        border-radius:10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .form-item{
          width: 50%;
          margin: 10px auto;
          text-align: center;
          /deep/.el-form-item__content{
            display: flex;
            justify-content: center;
            i{
              color: rgba(90,141,199,1);
              font-size: 26px;
            }
            .el-input {
              width: 80%;
              padding-left: 4%
            }
            .el-input__inner{
              opacity: 0.8;
            }
            .el-input__suffix{
              padding-top: 10px;
            }
          }
        }
        .login-btn{
          width: 50%;
        }
      }
    }
  }
</style>
